import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DashboardResponse, PayloadParam } from '@core/interface/dashboard';
import { environment } from '@environment/environment';

@Injectable({
  providedIn: 'root',
})
export class DashboardService {
  constructor(private http: HttpClient) {}

  getDashboardData(param: PayloadParam) {
    let httpParams = new HttpParams();
    if (param)
      Object.keys(param).forEach((key) => {
        httpParams = httpParams.set(
          key,
          (param[key as keyof PayloadParam] as any) || ''
        );
      });
    return this.http.get<DashboardResponse>(environment.endPoints.dashboard, {
      params: httpParams,
    });
  }
}
